import { render, staticRenderFns } from "./BookingModal.vue?vue&type=template&id=131ce4a9"
import script from "./BookingModal.vue?vue&type=script&lang=js"
export * from "./BookingModal.vue?vue&type=script&lang=js"
import style0 from "./BookingModal.vue?vue&type=style&index=0&id=131ce4a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports